import * as Yup from "yup";

// let patternTwoDigisAfterComma = /^\d+\.\d{2}$/;

const validFileExtensions = {
  image: ["jpg", "png"],
};

function isValidFileType(fileName, fileType) {
  return (
    fileName &&
    validFileExtensions[fileType].indexOf(fileName.split(".").pop()) > -1
  );
}

export const addNewLocationValidationSchema = Yup.object().shape({
  canco_site_id: Yup.string().required("This is a required field"),
  ackroo_canco_location: Yup.string().required("This is a required field"),
  name: Yup.string()
    .matches(/^[a-zA-Z',\W]+$/, "Only Alphabets are allowed")
    .required("This is a required field"),
  city: Yup.string().required("This is a required field"),
  province: Yup.string().required("This is a required field"),
  business_type: Yup.string().required("This is a required field"),
  address: Yup.string().required("This is a required field"),
  latitude: Yup.string().required("This is a required field"),
  longitude: Yup.string().required("This is a required field"),
  // postal: Yup.string().required("This is a required field"),
  amenities: Yup.array()
    .min(1, "Select at least one amenity")
    .required("Please select amenities"),
  gas_types: Yup.array()
    .min(1, "Select at least one gas type")
    .required("Please select gas types"),
});

export const addNewGasLocationValidationSchema = Yup.object().shape({
  gas_site_id: Yup.string().required("This is a required field"),
  // ackroo_canco_location: Yup.string().required("This is a required field"),
  name: Yup.string()
    .matches(/^[a-zA-Z',\W]+$/, "Only Alphabets are allowed")
    .required("This is a required field"),
  city: Yup.string().required("This is a required field"),
  province: Yup.string().required("This is a required field"),
  business_type: Yup.string().required("This is a required field"),
  address: Yup.string().required("This is a required field"),
  latitude: Yup.string().required("This is a required field"),
  longitude: Yup.string().required("This is a required field"),
  // postal: Yup.string().required("This is a required field"),
  amenities: Yup.array()
    .min(1, "Select at least one amenity")
    .required("Please select amenities"),
  gas_types: Yup.array()
    .min(1, "Select at least one gas type")
    .required("Please select gas types"),
});

export const addSubAdminValidationSchema = Yup.object().shape({
  first_name: Yup.string()
    .matches(/^[a-zA-Z\s]*$/, "Only Alphabets are allowed")
    .required("This is a required field"),
  last_name: Yup.string()
    .matches(/^[a-zA-Z\s]*$/, "Only Alphabets are allowed")
    .required("This is a required field"),
  email: Yup.string()
    .email("Invalid Email")
    .required("This is a required Field"),
  password: Yup.string().required("This is a required field"),
});

export const editSubAdminValidationSchema = Yup.object().shape({
  first_name: Yup.string()
    .matches(/^[a-zA-Z\s]*$/, "Only Alphabets are allowed")
    .required("This is a required field"),
  last_name: Yup.string()
    .matches(/^[a-zA-Z\s]*$/, "Only Alphabets are allowed")
    .required("This is a required field"),
  email: Yup.string()
    .email("Invalid Email")
    .required("This is a required Field"),
  // password: Yup.string().required("This is a required field"),
});

export const addPromotionValidationSchema = Yup.object().shape({
  name: Yup.string().required("This is a required field"),
  price: Yup.string()
    .required("This is a required field")
    .test("decimalPlaces", "Must have exactly 2 decimal places", (value) => {
      if (value === undefined) return true; // Allow empty input
      return /^-?\d+(\.\d{1,2})?$/.test(value.toString());
    }),
  multiplier: Yup.string().required("This is a required Field"),
  details: Yup.string().required("This is a required field"),
  product_inclusion: Yup.string().required("This is a required field"),
  effective_date: Yup.string().required("This is a required field"),
  expiration_date: Yup.string().required("This is a required field"),
  image: Yup.string().required("This is a required field"),
  banner: Yup.string().required("This is a required field"),
});

export const addWebPromotionValidationSchema = Yup.object().shape({
  name: Yup.string().required("This is a required field"),
  // effective_date: Yup.string().required("This is a required field"),
  // expiration_date: Yup.string().required("This is a required field"),
  image: Yup.string().required("This is a required field"),
  category: Yup.string().required("This is a required field"),
  // sequence_number: Yup.number("Invalid Number").required("This is a required field"),
  effective_date: Yup.date()
    .default(() => new Date())
    .required("This is a required field"),
  expiration_date: Yup.date()
    .when(
      "effective_date",
      (effective_date, schema) =>
        effective_date &&
        schema.min(
          effective_date,
          "Expiration Date cannot be less than Effective Date"
        )
    )
    .required("This is a required field"),
});

export const addPropanePromotionValidationSchema = Yup.object().shape({
  name: Yup.string()
    .max(100, "Promotion name must be 100 characters or less")
    .required("This is a required field"),
  description: Yup.string()
    .max(500, "Description must be 500 characters or less")
    .required("This is a required field"),
  effective_date: Yup.date()
    .default(() => new Date())
    .required("This is a required field"),
  expiration_date: Yup.date()
    .when(
      "effective_date",
      (effective_date, schema) =>
        effective_date &&
        schema.min(
          effective_date,
          "Expiration Date cannot be less than Effective Date"
        )
    )
    .required("This is a required field"),
  image: Yup.mixed()
    .required("This is a required field")
    .test("is-valid-type", "Upload valid image (.jpg, .png only)", (value) =>
      value && isValidFileType(value.name?.toLowerCase(), "image")
    )
    .test("file-size", "File size must be less than or equal to 4MB", (value) =>
      value && value.size <= 4 * 1024 * 1024
    ),
  link: Yup.string()
    .url("Please enter a valid URL")
    .required("This is a required field"),
});

export const editPropanePromotionValidationSchema = Yup.object().shape({
  name: Yup.string()
    .max(100, "Promotion name must be 100 characters or less")
    .required("This is a required field"),
  description: Yup.string()
    .max(500, "Description must be 500 characters or less")
    .required("This is a required field"),
  effective_date: Yup.date()
    .default(() => new Date())
    .required("This is a required field"),
  expiration_date: Yup.date()
    .when(
      "effective_date",
      (effective_date, schema) =>
        effective_date &&
        schema.min(
          effective_date,
          "Expiration Date cannot be less than Effective Date"
        )
    )
    .required("This is a required field"),
  image: Yup.mixed()
    .test("is-valid-type", "Upload valid image (.jpg, .png only)", (value) => {
      // If no value or empty string, validation passes (no new image uploaded)
      if (!value || value === "" || (typeof value === 'string' && value.trim() === "")) {
        return true;
      }
      // If it's a File object (new image uploaded), validate it
      if (value instanceof File) {
        return isValidFileType(value.name?.toLowerCase(), "image");
      }
      return true;
    })
    .test("file-size", "File size must be less than or equal to 4MB", (value) => {
      // If no value or empty string, validation passes (no new image uploaded)
      if (!value || value === "" || (typeof value === 'string' && value.trim() === "")) {
        return true;
      }
      // If it's a File object (new image uploaded), validate it
      if (value instanceof File) {
        return value.size <= 4 * 1024 * 1024;
      }
      return true;
    }),
  link: Yup.string()
    .url("Please enter a valid URL")
    .required("This is a required field"),
});

export const addBannerValidationSchema = Yup.object().shape({
  banner: Yup.mixed()
    .required("This is required field")
    .test("is-valid-type", "Upload valid image (.png, .jpg, .jpeg)", (value) =>
      isValidFileType(value && value.name.toLowerCase(), "image")
    ),
  module: Yup.string().required("This is a required field"),
});

export const editBannerValidationSchema = Yup.object().shape({
  banner: Yup.mixed().test(
    "is-valid-type",
    "Upload valid image (.png, .jpg, .jpeg)",
    (value) =>
      value
        ? isValidFileType(value && value.name?.toLowerCase(), "image")
        : true
  ),
  sequence: Yup.string().required("This is a required field"),
});

export const addBlogValidationSchema = Yup.object().shape({
  title: Yup.string().required("This is a required field"),
  content: Yup.string().required("This is a required field"),
  image: Yup.string().required("This is a required field"),
});

export const addPropanePopupValidationSchema = Yup.object().shape({
  title: Yup.string().required("This is a required field"),
  caption: Yup.string()
    .max(100, "Caption must be 100 characters or less")
    .required("This is a required field"),
  image: Yup.mixed()
    .required("This is a required field")
    .test("is-valid-type", "Upload valid image (.jpg, .png only)", (value) =>
      value && isValidFileType(value.name?.toLowerCase(), "image")
    )
    .test("file-size", "File size must be less than or equal to 4MB", (value) =>
      value && value.size <= 4 * 1024 * 1024
    ),
  link: Yup.string().required("This is a required field"),
});

export const editPropanePopupValidationSchema = Yup.object().shape({
  title: Yup.string().required("This is a required field"),
  caption: Yup.string()
    .max(100, "Caption must be 100 characters or less")
    .required("This is a required field"),
  image: Yup.mixed()
    .test("is-valid-type", "Upload valid image (.jpg, .png only)", (value) => {
      // If no value or empty string, validation passes (no new image uploaded)
      if (!value || value === "" || (typeof value === 'string' && value.trim() === "")) {
        return true;
      }
      // If it's a File object (new image uploaded), validate it
      if (value instanceof File) {
        return isValidFileType(value.name?.toLowerCase(), "image");
      }
      return true;
    })
    .test("file-size", "File size must be less than or equal to 4MB", (value) => {
      // If no value or empty string, validation passes (no new image uploaded)
      if (!value || value === "" || (typeof value === 'string' && value.trim() === "")) {
        return true;
      }
      // If it's a File object (new image uploaded), validate size
      if (value instanceof File) {
        return value.size <= 4 * 1024 * 1024;
      }
      return true;
    }),
  link: Yup.string().required("This is a required field"),
});
